<div class="test-data-agent-sse-container">
  <h2>Test Data Agent SSE</h2>

  <!-- Connection Status -->
  <div class="connection-status">
    <mat-icon [ngClass]="'status-' + connectionState.toLowerCase()">
      {{ connectionState === 'OPEN' ? 'wifi' : connectionState === 'CONNECTING' ? 'wifi_tethering' : 'wifi_off' }}
    </mat-icon>
    <span>Estado: {{ connectionState }}</span>
  </div>

  <!-- Request Configuration -->
  <div class="request-config">
    <div class="config-row">
      <mat-form-field appearance="outline">
        <mat-label>Agent Type</mat-label>
        <input matInput [(ngModel)]="agentType" name="agentType" placeholder="insight" [disabled]="isLoading" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Conversation ID</mat-label>
        <input
          matInput
          [(ngModel)]="conversationId"
          name="conversationId"
          placeholder="test-conv-001"
          [disabled]="isLoading"
        />
      </mat-form-field>

      <mat-checkbox [(ngModel)]="streamEnabled" name="streamEnabled" [disabled]="isLoading">
        Stream enabled
      </mat-checkbox>
    </div>
  </div>

  <!-- Message Input -->
  <div class="message-input">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Mensaje para el Data Agent</mat-label>
      <textarea
        matInput
        [(ngModel)]="message"
        name="message"
        placeholder="Ingresa tu mensaje aquí..."
        rows="3"
        [disabled]="isLoading"
      ></textarea>
    </mat-form-field>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button mat-raised-button color="primary" (click)="testSSEConnection()" [disabled]="isLoading">
      {{ isLoading ? 'Streaming...' : 'Test SSE Stream' }}
    </button>

    <button mat-raised-button color="accent" (click)="testConnection()" [disabled]="isLoading">
      {{ isLoading ? 'Testing...' : 'Test Connection' }}
    </button>

    <button mat-raised-button color="warn" (click)="stopStream()" [disabled]="!isLoading">Stop Stream</button>

    <button mat-stroked-button (click)="clearEvents()">Clear Events</button>
  </div>

  <!-- Error Display -->
  <div class="error-message" *ngIf="error">
    <mat-icon>error</mat-icon>
    <span>{{ error }}</span>
  </div>

  <!-- Main Content Tabs -->
  <mat-tab-group *ngIf="events.length > 0" class="content-tabs">
    <!-- Reasoning Tab -->
    <mat-tab label="🧠 Razonamiento">
      <div class="tab-content">
        <!-- Razonamiento en tiempo real (durante streaming) -->
        <mat-card class="reasoning-card realtime-reasoning" *ngIf="shouldShowRealtimeReasoning()">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>psychology</mat-icon>
              {{ getCurrentCycleTitle() }}
            </mat-card-title>
            <mat-card-subtitle>
              Ciclo {{ currentCycle }} | {{ getCurrentReasoningText().length }} caracteres
              <span class="streaming-indicator" *ngIf="isLoading && !isPendingNewContent()">🟢 Streaming...</span>
              <span class="waiting-indicator" *ngIf="isPendingNewContent()">⏳ Esperando nuevo contenido...</span>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div
              class="reasoning-content markdown-content realtime-content"
              [class.streaming]="isLoading"
              [innerHTML]="getCurrentReasoningText() | markdown"
            ></div>
          </mat-card-content>
        </mat-card>

        <!-- Output final (cuando termina el streaming) - PERDURA -->
        <mat-card class="reasoning-card final-output" *ngIf="shouldShowFinalOutput()">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>done_all</mat-icon>
              Análisis Completado
            </mat-card-title>
            <mat-card-subtitle>Resultado final | {{ getFinalOutput().length }} caracteres</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div
              class="reasoning-content markdown-content final-content"
              [innerHTML]="getFinalOutput() | markdown"
            ></div>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button color="primary" (click)="toggleCycleHistory()">
              <mat-icon>{{ showCycleHistory ? 'expand_less' : 'expand_more' }}</mat-icon>
              {{ showCycleHistory ? 'Ocultar Proceso' : 'Ver Proceso de Razonamiento' }}
            </button>
          </mat-card-actions>
        </mat-card>

        <!-- Historial de ciclos expandible -->
        <mat-card class="reasoning-card process-details" *ngIf="shouldShowCycleHistory()">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>timeline</mat-icon>
              Proceso de Razonamiento por Ciclos
            </mat-card-title>
            <mat-card-subtitle>{{ getCycleHistory().length }} ciclos de razonamiento</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div *ngFor="let cycle of getCycleHistory(); trackBy: trackByCycle" class="cycle-section">
              <h4 class="cycle-title">
                <mat-icon>trip_origin</mat-icon>
                Ciclo {{ cycle.cycle }}: {{ cycle.title }}
              </h4>
              <div
                class="reasoning-content markdown-content cycle-content"
                [innerHTML]="cycle.content | markdown"
              ></div>
              <mat-divider *ngIf="!$last"></mat-divider>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button color="accent" (click)="toggleCycleHistory()">
              <mat-icon>expand_less</mat-icon>
              Ocultar Proceso por Ciclos
            </button>
          </mat-card-actions>
        </mat-card>

        <!-- Fallback - Último contenido disponible cuando no hay output final -->
        <mat-card
          class="reasoning-card fallback-content"
          *ngIf="isStreamComplete && !shouldShowFinalOutput() && !shouldShowRealtimeReasoning() && getCurrentReasoningText().length > 0"
        >
          <mat-card-header>
            <mat-card-title>
              <mat-icon>error_outline</mat-icon>
              Último Contenido Disponible
            </mat-card-title>
            <mat-card-subtitle>Stream completado | {{ getCurrentReasoningText().length }} caracteres</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div
              class="reasoning-content markdown-content final-content"
              [innerHTML]="getCurrentReasoningText() | markdown"
            ></div>
          </mat-card-content>
        </mat-card>

        <!-- Estado vacío -->
        <div
          class="empty-reasoning"
          *ngIf="!shouldShowRealtimeReasoning() && !shouldShowFinalOutput() && (!isStreamComplete || getCurrentReasoningText().length === 0)"
        >
          <mat-icon>psychology</mat-icon>
          <p>El razonamiento aparecerá aquí conforme se genere...</p>
        </div>
      </div>
    </mat-tab>

    <!-- Debug Tab -->
    <mat-tab label="🔧 Debug & Eventos">
      <div class="tab-content">
        <mat-card class="debug-card" *ngIf="getDebugInfo().length > 0">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>bug_report</mat-icon>
              Información de Debug
            </mat-card-title>
            <mat-card-subtitle>Eventos del sistema y herramientas</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="debug-content">
              <pre>{{ getDebugInfo() }}</pre>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="empty-debug" *ngIf="getDebugInfo().length === 0">
          <mat-icon>bug_report</mat-icon>
          <p>La información de debug aparecerá aquí...</p>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Results -->
  <div class="results-container" *ngIf="events.length > 0">
    <h3>Events ({{ events.length }}):</h3>

    <!-- Quick Stats -->
    <div class="event-stats" *ngIf="events.length > 0">
      <div class="stat-item">
        <strong>Start:</strong>
        {{ getEventsByType('start').length }}
      </div>
      <div class="stat-item">
        <strong>Progress:</strong>
        {{ getEventsByType('progress').length }}
      </div>
      <div class="stat-item">
        <strong>Complete:</strong>
        {{ getEventsByType('complete').length }}
      </div>
      <div class="stat-item">
        <strong>Errors:</strong>
        {{ getEventsByType('error').length }}
      </div>
    </div>

    <!-- Last Event -->
    <div class="last-event" *ngIf="getLastEvent() as lastEvent">
      <h4>Último Evento:</h4>
      <div class="event-card" [ngClass]="'event-' + lastEvent.type">
        <div class="event-header">
          <mat-icon>
            {{ lastEvent.type === 'complete' ? 'check_circle' : lastEvent.type === 'error' ? 'error' : 'info' }}
          </mat-icon>
          <span class="event-type">{{ lastEvent.type | titlecase }}</span>
          <span class="event-time" *ngIf="lastEvent.timestamp">{{ lastEvent.timestamp | date:'HH:mm:ss' }}</span>
        </div>
        <div class="event-content" *ngIf="lastEvent.content">
          <pre>{{ lastEvent.content }}</pre>
        </div>
        <div class="event-error" *ngIf="lastEvent.error">
          <strong>Error:</strong>
          {{ lastEvent.error }}
          <div class="debug-info" *ngIf="lastEvent.debugInfo">
            <mat-icon>info</mat-icon>
            <span>{{ lastEvent.debugInfo }}</span>
          </div>
          <div class="troubleshooting" *ngIf="lastEvent.metadata?.troubleshooting">
            <mat-icon>build</mat-icon>
            <strong>Solución:</strong>
            {{ lastEvent.metadata.troubleshooting }}
          </div>
        </div>
      </div>
    </div>

    <!-- All Events -->
    <details class="all-events">
      <summary>Ver todos los eventos ({{ events.length }})</summary>
      <div class="events-list">
        <div
          class="event-item"
          *ngFor="let event of events; trackBy: trackByTimestamp"
          [ngClass]="'event-' + event.type"
        >
          <div class="event-info">
            <span class="event-type">{{ event.type }}</span>
            <span class="event-time" *ngIf="event.timestamp">{{ event.timestamp | date:'HH:mm:ss.SSS' }}</span>
          </div>

          <div class="event-data" *ngIf="event.content || event.text || event.message">
            <div *ngIf="event.type === 'init'" class="init-info">
              <strong>Inicialización:</strong>
              {{ event.message }}
            </div>
            <div *ngIf="event.type === 'text_chunk'" class="text-chunk">
              <strong>Chunk:</strong>
              <span>{{ event.content || event.text }}</span>
            </div>
            <div *ngIf="event.type === 'cycle_start'" class="cycle-info">
              <strong>Iniciando ciclo {{ event.cycle }}...</strong>
            </div>
            <div *ngIf="event.type === 'tool_use'" class="tool-use">
              <strong>Usando herramienta:</strong>
              {{ event.content || event.message }}
            </div>
            <div *ngIf="event.type === 'tool_result'" class="tool-result">
              <strong>Resultado:</strong>
              {{ event.content || event.message }}
            </div>
            <div
              *ngIf="!['init', 'text_chunk', 'cycle_start', 'tool_use', 'tool_result'].includes(event.type)"
              class="generic-content"
            >
              <pre>{{ event.content || event.text || event.message }}</pre>
            </div>
          </div>

          <div class="event-error" *ngIf="event.error">
            <strong>Error:</strong>
            {{ event.error }}
            <div class="debug-info" *ngIf="event.debugInfo">
              <mat-icon>info</mat-icon>
              <span>{{ event.debugInfo }}</span>
            </div>
            <div class="troubleshooting" *ngIf="event.metadata?.troubleshooting">
              <mat-icon>build</mat-icon>
              <strong>Solución:</strong>
              {{ event.metadata.troubleshooting }}
            </div>
          </div>
        </div>
      </div>
    </details>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="events.length === 0 && !isLoading">
    <mat-icon>chat_bubble_outline</mat-icon>
    <p>No hay eventos. Inicia un stream para ver los resultados aquí.</p>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading && events.length === 0">
    <mat-spinner></mat-spinner>
    <p>Estableciendo conexión SSE...</p>
  </div>
</div>
